import React, { useEffect, useState } from "react";
import { Container, Grid } from '@mui/material';

import UserTable from "./userTable";
import ButtonsOptions from "./buttonsOptions";
import Autocomplete from '@mui/material/Autocomplete';
import FormCard from "../../components/forms/formCard";
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';

//import MyTextField from "./userList"

import { api } from '../../services/api';

const User = props => {
    const [usersList, setUsersList] = useState([]);
    const [field, setField] = useState("");
    const [valuesList, setValuesList] = useState([]);
    const [srcUsersList, setSrcUsersList] = useState([]);
    
    const mapFields = {
        "Nome": "nome",
        "Email": "email",
        "Setor": "setor",
        "Papel": "role",
        "Status": "status"
    }

    const statusValue = [
        "Ativo",
        "Inativo"
    ]

  useEffect(() => {
      let mounted = true;
      api.getUsers()
        .then(resp => {
            if (mounted && resp) {
                setUsersList(resp);
                setSrcUsersList(resp);
            }
        })
      return () => mounted = false;
  }, [])

    const handleFieldSelect = (value) => {
        if (value) {
            let valuesFiltered = [];
            if (mapFields[value] === "status") {
                setValuesList(statusValue);
                setField(mapFields[value]);

            } else { 
                valuesFiltered = srcUsersList?.map(user => user[mapFields[value]]);

                setValuesList(valuesFiltered?.filter((item, index) => valuesFiltered.indexOf(item) === index));
                setField(mapFields[value]);
            }
        }
    }

    const handleValueSelect = (value) => {
        if (value && value?.length > 0) {
            let usersFiltered = [];
            if (field === "status") {
                if (value == "Ativo") {
                    usersFiltered = srcUsersList.filter(u => u.inativoDesde ===   null);
                    setUsersList(usersFiltered);
                }
                if (value == "Inativo") {
                    usersFiltered = srcUsersList.filter(u => u.inativoDesde !== null);
                    setUsersList(usersFiltered);
                }

            } else {
            usersFiltered = srcUsersList.filter(u => value.includes(u[field]));

            setUsersList(usersFiltered);
            }
        } else {
            setUsersList(srcUsersList);
        }
    };

  return (
      <Container maxWidth="xg" sx={{ mt: 4, mb: 4 }}>
          <Grid item xs={12}>
          <ButtonsOptions />
          </Grid>
          <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Paper variant="outlined" sx={{ my: { xs: 3, md: 1 }, p: { xs: 2, md: 3 }, borderRadius: '10px' }}>
                        <Grid item xs={12} sm={12}>
                            <FormCard title="Filtros">
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={2}>
                                        <Autocomplete
                                            size="small"
                                            disablePortal
                                            id="field"
                                            getOptionLabel={(option) => option}
                                            options={Object.keys(mapFields)}
                                            onChange={(event, value) => handleFieldSelect(value)}
                                            sx={{ width: "100%" }}
                                            renderInput={(params) => <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: "12px" } }}
                                                InputLabelProps={{ ...params.InputLabelProps, style: { fontSize: "12px" } }}
                                                label="Campo a ser filtrado" />}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={10}>
                                        <Autocomplete
                                            multiple
                                            size="small"
                                            disablePortal
                                            id="value"
                                            getOptionLabel={(option) => option}
                                            options={valuesList}
                                            onChange={(event, value) => handleValueSelect(value)}
                                            sx={{ width: "100%" }}
                                            renderInput={(params) => <TextField
                                                {...params}
                                                label="Conteúdo"
                                                InputProps={{ ...params.InputProps, style: { fontSize: "12px" } }}
                                                InputLabelProps={{ ...params.InputLabelProps, style: { fontSize: "12px" } }}
                                            />}
                                        />
                                    </Grid>
                                </Grid>
                            </FormCard>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
          <Grid item xs={12}>
              <UserTable rows={usersList}/>
          </Grid>
      </Container>
  );

};

export default User;
